import { render, staticRenderFns } from "./JudgeDetail.vue?vue&type=template&id=067b5b71&scoped=true&lang=pug&"
import script from "./JudgeDetail.vue?vue&type=script&lang=js&"
export * from "./JudgeDetail.vue?vue&type=script&lang=js&"
import style0 from "./JudgeDetail.vue?vue&type=style&index=0&id=067b5b71&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067b5b71",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VIcon,VLayout})
